import React from "react";
import { Link } from "react-router-dom";
import { EventStatusBadge } from "@/components/EventStatusBadge";
import { Countdown } from "@/components/Countdown";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export function StartingSoonCard({ item }) {
  const isLive = item.status === "live";
  const to = item.kind === "live" ? `/live/${item.id}` : `/event/${item.id}`;

  return (
    <Link
      to={to}
      data-testid={`starting-soon-${item.id}`}
      className="group block overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={item.thumbnail}
          alt={item.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute left-3 top-3 flex gap-2">
          <EventStatusBadge status={item.status} size="sm" />
          {item.type === "premium" && <EventStatusBadge status="premium" size="sm" />}
        </div>
        {/* Countdown or LIVE label */}
        <div className="absolute bottom-3 left-3 right-3">
          {isLive ? (
            <span className="inline-flex items-center gap-1.5 rounded-full bg-live px-3 py-1.5 text-xs font-bold text-white">
              <span className="h-2 w-2 animate-pulse rounded-full bg-white" /> Streaming now
            </span>
          ) : (
            <Countdown target={item.startsAt} />
          )}
        </div>
      </div>
      <div className="space-y-2 p-4">
        <h3 className="line-clamp-1 font-heading text-base font-bold tracking-tight text-foreground">
          {item.title}
        </h3>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Avatar className="h-6 w-6">
              <AvatarImage src={item.host.avatar} alt={item.host.displayName} />
              <AvatarFallback>{item.host.displayName[0]}</AvatarFallback>
            </Avatar>
            <span className="text-sm text-muted-foreground">{item.host.displayName}</span>
          </div>
          {item.priceFrom && (
            <span className="text-sm font-semibold text-brand">From {item.priceFrom}</span>
          )}
        </div>
      </div>
    </Link>
  );
}

export default StartingSoonCard;
